/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import customStyles from "../../../assets/styles/customStyles";
import MainHeader from "../../Shared/components/Header";
import { Row, Col } from "antd";
import Menus from "./Menus";
import SettingsImg from "../../../assets/images/icon_menus/SettingsIcon.json";
import { Trend, MonthlySales, Total, NetGST, NoData, NetIncome } from "../../Shared/components/Dashboard";
import { checkModuleViewPermission } from '../../../helpers/utilities';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
    Navigation,
    Pagination,
    Autoplay,
    Virtual
} from "swiper/core";
import { useDispatch, useSelector } from "react-redux";
import action from "./redux/actions";

SwiperCore.use([Navigation, Pagination, Autoplay, Virtual]);

const Admin = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);
    const { adminDashboardDetails } = useSelector(state => state.adminDashboardReducer);
    const [height, setHeight] = useState(300);
    const [menuHeight, setMenuHeight] = useState(0);
    const leftRef = useRef('');
    const dispatch = useDispatch();
    const { history } = props;
    const [customIndex, setCustomIndex] = useState(0);
    const [adminIndex, setAdminIndex] = useState(0);


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkModuleViewPermission('Purchase', history)) {
                loadTasks();
                setTimeout(() => {
                    calculateHeight();
                }, 100);
            }
        }
    }, [roleManagement]);




    const calculateHeight = () => {
        if (document.querySelectorAll(`.menuCheck`).length > 0) {
            if (leftRef && leftRef?.current)
                setMenuHeight(leftRef.current.offsetHeight + 25);
            if (document.querySelectorAll(`.${classes.primaryMenu}`) && document.querySelectorAll(`.${classes.primaryMenu}`).length > 0 && leftRef.current) {
                let height = document.querySelectorAll(`.${classes.primaryMenu}`)[0].offsetHeight;
                let offsetHeight = leftRef?.current?.offsetHeight + height + 23;
                setHeight(offsetHeight);
            }
        }
    }

    const loadTasks = useCallback(() => {
        dispatch({ type: action.ADMIN_DASHBOARD_START, url: 'admindashboard' });
    });

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Admin', 'link': '' }]} close={false} />
            <div className={clsx(classes.listTableMargin, classes.containerBorder, classes.cardEHeight)}>
                <Row gutter={25} className={classes.dashboardRow}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={16} xxl={16}>
                        <Row gutter={25} ref={leftRef}>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            adminDashboardDetails !== undefined && adminDashboardDetails !== '' ?
                                                <>
                                                    {
                                                        adminDashboardDetails?.sales_trend?.invoices.reduce((a, v) => a = a + v, 0) === 0 ? <NoData /> :
                                                            <Trend title="Sales Trend"
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or credit note"
                                                                months={adminDashboardDetails?.sales_trend?.months}
                                                                invoiceCounts={adminDashboardDetails?.sales_trend?.invoices}
                                                                invoiceAmounts={adminDashboardDetails?.sales_trend?.amounts}
                                                            />
                                                    }
                                                </>
                                                : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className={classes.secondBox}>
                                <div className={clsx(classes.boxBorder)}>
                                    <div className={clsx(classes.boxBorderInner)}>
                                        {
                                            adminDashboardDetails !== undefined && adminDashboardDetails !== '' ?

                                                <Swiper
                                                    id="swiper-admin-details"
                                                    virtual
                                                    autoplay={{
                                                        delay: 5000,
                                                        pauseOnMouseEnter: true
                                                    }}
                                                    onSlideChange={(swiper) => { setCustomIndex(swiper.activeIndex); }}
                                                    modules={[Navigation]}
                                                    slideActiveClass={classes.activeSlider}
                                                    loop
                                                    pagination={{ clickable: true }}>
                                                    <SwiperSlide key={`slide-1`} style={{ listStyle: "none" }}>
                                                        {
                                                            (customIndex === 1 || customIndex === 4) &&
                                                            <>
                                                                {
                                                                    adminDashboardDetails?.last_month_net_total === 0 &&
                                                                        adminDashboardDetails?.current_month_net_total === 0 ? <NoData /> :
                                                                        <NetIncome title="Net Income Comparison" swiper="swiper-admin-details"
                                                                            sTitle="Net"
                                                                            monthPercent={adminDashboardDetails?.month_net_percent}
                                                                            currentMonthTotal={adminDashboardDetails?.current_month_net_total}
                                                                            lastMonthTotal={adminDashboardDetails?.last_month_net_total}
                                                                            percent_type={adminDashboardDetails?.percent_net_type}
                                                                        />
                                                                }
                                                            </>
                                                        }
                                                    </SwiperSlide>
                                                    <SwiperSlide key={`slide-2`} style={{ listStyle: "none" }}>
                                                        {
                                                            customIndex === 2 &&
                                                            <>
                                                                {
                                                                    adminDashboardDetails?.sales_monthly_comparision?.current_month_sales_total === 0 && adminDashboardDetails?.sales_monthly_comparision?.last_month_sales_total === 0 ? <NoData /> :
                                                                        <MonthlySales title="Monthly Sales Comparison" swiper="swiper-admin-details"
                                                                            sTitle="Sales"
                                                                            toolTip="Values displayed includes only original transaction data and does not include any reversals or credit note"
                                                                            monthPercent={adminDashboardDetails?.sales_monthly_comparision?.month_sales_percent}
                                                                            currentMonthTotal={adminDashboardDetails?.sales_monthly_comparision?.current_month_sales_total}
                                                                            lastMonthTotal={adminDashboardDetails?.sales_monthly_comparision?.last_month_sales_total}
                                                                            percent_type={adminDashboardDetails?.sales_monthly_comparision?.percent_type}
                                                                        />
                                                                }
                                                            </>
                                                        }
                                                    </SwiperSlide>
                                                    <SwiperSlide key={`slide-3`} style={{ listStyle: "none" }}>
                                                        {
                                                            customIndex === 3 &&
                                                            <>
                                                                {
                                                                    adminDashboardDetails?.purchase_monthly_comparision?.current_month_purchase_total === 0 &&
                                                                        adminDashboardDetails?.purchase_monthly_comparision?.last_month_purchase_total === 0 ? <NoData /> :
                                                                        <MonthlySales title="Monthly Purchase Comparison" swiper="swiper-admin-details"
                                                                            sTitle="Purchase"
                                                                            toolTip="Values displayed includes only original transaction data and does not include any reversals or debit note"
                                                                            monthPercent={adminDashboardDetails?.purchase_monthly_comparision?.month_purchase_percent}
                                                                            currentMonthTotal={adminDashboardDetails?.purchase_monthly_comparision?.current_month_purchase_total}
                                                                            lastMonthTotal={adminDashboardDetails?.purchase_monthly_comparision?.last_month_purchase_total}
                                                                            percent_type={adminDashboardDetails?.purchase_monthly_comparision?.percent_purchase_type}
                                                                        />
                                                                }
                                                            </>
                                                        }
                                                    </SwiperSlide>
                                                </Swiper> : <div className={classes.loadMoreCircle}></div>
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        {
                            roleManagement !== '' && <Menus menuHeight={menuHeight} />
                        }
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8} className={classes.thirdBox}>
                        <div className={clsx(classes.boxBorderH)} style={{ height: (height) + 'px' }}>
                            {
                                adminDashboardDetails !== undefined && adminDashboardDetails !== '' ?
                                    <Swiper
                                        loop
                                        virtual
                                        autoplay={{
                                            delay: 5000,
                                            pauseOnMouseEnter: true
                                        }}
                                        modules={[Navigation]}
                                        slideActiveClass={classes.activeSlider}
                                        onReachEnd={() => {
                                        }}
                                        onSlideChange={(swiper) => { setAdminIndex(swiper.activeIndex); }}
                                        pagination={{ clickable: true }}>
                                        <SwiperSlide key={`slide-1`} style={{ listStyle: "none" }}>
                                            {
                                                (adminIndex === 1 || adminIndex === 5) && <>
                                                    {
                                                        adminDashboardDetails?.total_sales_15 === 0 &&
                                                            adminDashboardDetails?.total_sales_30 === 0 &&
                                                            adminDashboardDetails?.total_sales_90 === 0 ? <NoData /> : <Total title="Total Sales"
                                                                sTitle={"Sales Total"}
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or credit note"
                                                                total_sales_15={parseFloat(adminDashboardDetails?.total_sales_15).toFixed(2)}
                                                                total_sales_30={parseFloat(adminDashboardDetails?.total_sales_30).toFixed(2)}
                                                                total_sales_90={parseFloat(adminDashboardDetails?.total_sales_90).toFixed(2)} />
                                                    }
                                                </>
                                            }
                                        </SwiperSlide>
                                        <SwiperSlide key={`slide-2`} style={{ listStyle: "none" }}>
                                            {
                                                adminIndex === 2 && <>
                                                    {
                                                        adminDashboardDetails?.total_purchase_15 === 0 &&
                                                            adminDashboardDetails?.total_purchase_30 === 0 &&
                                                            adminDashboardDetails?.total_purchase_90 === 0 ? <NoData /> : <Total title="Total Purchase"
                                                                sTitle={"Purchase Total"}
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or debit note"
                                                                total_sales_15={parseFloat(adminDashboardDetails?.total_purchase_15).toFixed(2)}
                                                                total_sales_30={parseFloat(adminDashboardDetails?.total_purchase_30).toFixed(2)}
                                                                total_sales_90={parseFloat(adminDashboardDetails?.total_purchase_90).toFixed(2)} />
                                                    }
                                                </>
                                            }
                                        </SwiperSlide>
                                        <SwiperSlide key={`slide-3`} style={{ listStyle: "none" }}>
                                            {
                                                adminIndex === 3 && <>
                                                    {
                                                        adminDashboardDetails?.net_income_15 === 0 &&
                                                            adminDashboardDetails?.net_income_30 === 0 &&
                                                            adminDashboardDetails?.net_income_90 === 0 ? <NoData /> : <Total title="Net Income"
                                                                sTitle={"Net Income"}
                                                                toolTip="Values displayed includes only original transaction data and does not include any reversals or credit note"
                                                                total_sales_15={parseFloat(adminDashboardDetails?.net_income_15).toFixed(2)}
                                                                total_sales_30={parseFloat(adminDashboardDetails?.net_income_30).toFixed(2)}
                                                                total_sales_90={parseFloat(adminDashboardDetails?.net_income_90).toFixed(2)} />
                                                    }
                                                </>
                                            }
                                        </SwiperSlide>
                                        {
                                            businessDetails?.taxType?.taxCode !== 'UNRB' &&
                                            businessDetails?.taxType?.taxCode !== 'COMP' && <SwiperSlide key={`slide-4`} style={{ listStyle: "none" }}>
                                                {
                                                    adminIndex === 4 && <>
                                                        {
                                                            adminDashboardDetails?.gst_month?.gst_payable.reduce((a, v) => a = a + v, 0) === 0 &&
                                                                adminDashboardDetails?.gst_month?.gst_recieveble.reduce((a, v) => a = a + v, 0) === 0 ? <NoData /> : <NetGST title={"GST Details"} details={adminDashboardDetails} />
                                                        }
                                                    </>
                                                }
                                            </SwiperSlide>
                                        }
                                    </Swiper>
                                    : <div className={classes.loadMoreCircle}></div>
                            }
                        </div>
                    </Col>
                </Row>
            </div >
        </React.Fragment>
    )
}

export default Admin